export const CHART_HEIGHT = 178;
export const CHART_DESKTOP_MARGIN = 12;
export const CHART_MOBILE_MARGIN = 10;
export const CHART_DESKTOP_WIDTH = 464;
export const CHART_MOBILE_WIDTH = 288;
export const FONT_SIZE = 14;

export const CHART_DESKTOP_SPACING =
    (CHART_DESKTOP_WIDTH - 2 * CHART_DESKTOP_MARGIN) / 11;
export const CHART_MOBILE_SPACING =
    (CHART_MOBILE_WIDTH - 2 * CHART_MOBILE_MARGIN) / 11;

export const BAR_DESKTOP_WIDTH = (CHART_DESKTOP_WIDTH - 88) / 12;
export const BAR_DESKTOP_SPACING =
    (CHART_DESKTOP_WIDTH - BAR_DESKTOP_WIDTH) / 11;

export const BAR_MOBILE_WIDTH = (CHART_MOBILE_WIDTH - 22) / 12;
export const BAR_MOBILE_SPACING = (CHART_MOBILE_WIDTH - BAR_MOBILE_WIDTH) / 11;
